module.exports = __webpack_public_path__ + "static/img/ZM.3a8e47fa.svg";